/** @typedef {import('../shared/types').OverlayGroupDefinition} OverlayGroupDefinition */
import { defineOverlays, getUnsafeFn } from "../shared/functions";
import { BasicProgressBar } from "./basic";
import { MaxProgressBar } from "./max";
import { MinProgressBar } from "./min";
import { VerticalProgressBar } from "./vertical";
export const _ProgressBars = defineOverlays({
    basic: BasicProgressBar,
    max: MaxProgressBar,
    min: MinProgressBar,
    vertical: VerticalProgressBar,
});
export const PlayliveProgressBars = {
    ..._ProgressBars,
    get: (key) => {
        return _ProgressBars[key];
    },
    getAll: () => {
        return Object.values(_ProgressBars);
    },
    getUnsafe: (slugOrKey) => {
        return getUnsafeFn(PlayliveProgressBars.slugs(), _ProgressBars, slugOrKey);
    },
    slugs: () => {
        return PlayliveProgressBars.getAll().map((bar) => bar.slug);
    },
};
/** @typedef {OverlayGroupDefinition<ProgressBarKey> & ProgressBarMap} ProgressBarGroup */
/** @typedef {keyof ProgressBarMap} ProgressBarKey */
/** @typedef {typeof _ProgressBars} ProgressBarMap */
//# sourceMappingURL=index.js.map